import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import { getFileUploadURL, uploadFile } from '../../../actions/file-upload';
import { createCarrierLogo } from '../../../actions/logos';

class AddLogo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      error: false,
      carrierName: '',
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ file: e.target.files[0] });
  }

  render() {
    const { onAdd, creatingLogo, dispatch } = this.props;
    const { file, error, carrierName } = this.state;
    return (
      <Row className="mb-4 fade-in">
        <Col className="ms-5">
          <div className="d-flex align-items-baseline">
            <h4 className="mb-3">Add a Logo</h4>
            {error ? <div className="text-danger ms-3">Could Not Upload.</div> : null}
          </div>
          <div className="text-muted mb-1">Enter carrier logo name:</div>
          <div className="d-flex w-25 mb-4">
            <Input
              className="border me-3"
              onChange={(e) => this.setState({ carrierName: e.target.value })}
              value={carrierName}
              disabled={creatingLogo}
            />
          </div>
          <div className="mb-4 d-flex align-items-center">
            <Button
              outline
              className="me-3"
              disabled={!file || !carrierName || creatingLogo}
              onClick={() => {
                dispatch({ type: 'CREATING_LOGO', payload: true });
                getFileUploadURL(file.name, true)
                  .then((data) => {
                    const uploadURL = data.url;
                    const uploadFields = data.fields;

                    uploadFile(file, data)
                      .then(() => {
                        createCarrierLogo(carrierName, `${uploadURL}${uploadFields.key}`)
                          .then(() => {
                            onAdd();
                            dispatch({ type: 'CREATING_LOGO', payload: false });
                          }).catch(() => {
                            dispatch({ type: 'CREATING_LOGO', payload: false });
                            this.setState({ error: true });
                          });
                      })
                      .catch(() => {
                        dispatch({ type: 'CREATING_LOGO', payload: false });
                        this.setState({ error: true });
                      });
                  })
                  .catch(() => {
                    dispatch({ type: 'CREATING_LOGO', payload: false });
                    this.setState({ error: true });
                  });
              }}
            >
              {creatingLogo ? <Spinner size="sm" className="me-1" /> : null}
              Upload Logo
            </Button>
            <input type="file" onChange={this.onChange} disabled={creatingLogo} />
          </div>
          <div>
            Note: The carrier name will be used as a display name unless another
            display name is later provided. It will also be read by screen readers
            for the visually impaired.
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => ({
  creatingLogo: store.logos.creatingLogo,
});

export default connect(mapStateToProps)(AddLogo);
